<template>
    <button class="bg-gray-300 border border-gray-300  text-gray-600 whitespace-nowrap tracking-wider font-medium px-3 py-1 rounded-sm" disabled>
        <slot></slot>
    </button>
</template>

<script setup></script>